
document.addEventListener('DOMContentLoaded', function() {
  // Get all elements
  const timelineSection = document.querySelector('.timeline-section');
  const timelineItems = document.querySelectorAll('.timeline-item');
  const timelineLines = document.querySelectorAll('.timeline-line');
  const timelineNumbers = document.querySelectorAll('.timeline-number');
  const mainLineFill = document.querySelector('.main-line-fill');
  const progressFill = document.querySelector('.progress-fill');
  const progressText = document.querySelector('.progress-text');
  
  // Calculate total scrollable height
  const totalHeight = timelineSection.scrollHeight - window.innerHeight;
  
  // Function to update progress based on scroll
  function updateScrollProgress() {
    const scrollTop = window.pageYOffset;
    const scrollPercent = (scrollTop / totalHeight) * 100;
    
    // Update main timeline line fill
    if (mainLineFill) {
      mainLineFill.style.height = Math.min(scrollPercent, 100) + '%';
    }
    
    // Update progress indicator
    if (progressFill && progressText) {
      progressFill.style.width = scrollPercent + '%';
      progressText.textContent = `Timeline: ${Math.round(scrollPercent)}%`;
    }
    
    // Check if timeline is completed
    if (scrollPercent >= 100) {
      timelineSection.classList.add('completed');
    } else {
      timelineSection.classList.remove('completed');
    }
    
    // Update individual timeline items and lines
    timelineItems.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      const itemTop = rect.top + window.pageYOffset;
      const itemBottom = itemTop + rect.height;
      const viewportTop = window.pageYOffset;
      const viewportBottom = viewportTop + window.innerHeight;
      
      // Check if item is in viewport
      if (itemTop < viewportBottom && itemBottom > viewportTop) {
        // Calculate how much of the item is visible
        const visibleHeight = Math.min(viewportBottom, itemBottom) - Math.max(viewportTop, itemTop);
        const itemPercent = (visibleHeight / rect.height) * 100;
        
        // If item is more than 50% visible, mark as active
        if (itemPercent > 50) {
          item.classList.add('active');
          
          // Mark number as active
          const number = item.querySelector('.timeline-number');
          if (number) number.classList.add('active');
          
          // Fill the lines connected to this item
          const lines = item.querySelectorAll('.timeline-line');
          lines.forEach(line => {
            const lineFill = line.querySelector('.line-fill');
            if (lineFill) {
              // Calculate fill percentage based on scroll position relative to item
              const lineRect = line.getBoundingClientRect();
              const lineScrollPercent = Math.min(100, Math.max(0, 
                (viewportBottom - lineRect.top) / lineRect.height * 100
              ));
              
              lineFill.style.height = lineScrollPercent + '%';
              line.classList.add('filled');
            }
          });
          
          // Fill previous items' lines completely
          for (let i = 0; i < index; i++) {
            const prevItem = timelineItems[i];
            const prevLines = prevItem.querySelectorAll('.timeline-line');
            prevLines.forEach(line => {
              const lineFill = line.querySelector('.line-fill');
              if (lineFill) {
                lineFill.style.height = '100%';
                line.classList.add('filled');
              }
            });
          }
        } else {
          item.classList.remove('active');
          const number = item.querySelector('.timeline-number');
          if (number) number.classList.remove('active');
        }
      } else if (itemTop < viewportTop) {
        // Item is above viewport - mark as completed
        item.classList.add('active');
        const number = item.querySelector('.timeline-number');
        if (number) number.classList.add('active');
        
        const lines = item.querySelectorAll('.timeline-line');
        lines.forEach(line => {
          const lineFill = line.querySelector('.line-fill');
          if (lineFill) {
            lineFill.style.height = '100%';
            line.classList.add('filled');
          }
        });
      } else {
        // Item is below viewport
        item.classList.remove('active');
        const number = item.querySelector('.timeline-number');
        if (number) number.classList.remove('active');
      }
    });
  }
  
  // Initial update
  updateScrollProgress();
  
  // Update on scroll with throttling
  let isScrolling = false;
  window.addEventListener('scroll', () => {
    if (!isScrolling) {
      window.requestAnimationFrame(() => {
        updateScrollProgress();
        isScrolling = false;
      });
      isScrolling = true;
    }
  });
  
  // Update on resize
  window.addEventListener('resize', () => {
    totalHeight = timelineSection.scrollHeight - window.innerHeight;
    updateScrollProgress();
  });
  
  // Smooth scroll to timeline items when clicked
  timelineNumbers.forEach(number => {
    number.addEventListener('click', function() {
      const item = this.closest('.timeline-item');
      if (item) {
        const offsetTop = item.offsetTop - 100;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    });
  });
  
  // Add hover effects for lines
  timelineLines.forEach(line => {
    line.addEventListener('mouseenter', function() {
      this.style.transform = 'scale(1.2)';
    });
    
    line.addEventListener('mouseleave', function() {
      this.style.transform = 'scale(1)';
    });
  });
  
  // Initialize all lines with 0% fill
  timelineLines.forEach(line => {
    const lineFill = line.querySelector('.line-fill');
    if (lineFill) {
      lineFill.style.height = '0%';
    }
  });
});
